export const getFormatedCarName = (incomingCarMake) => {
    const wordArray = incomingCarMake.split(' ');

    const mappedWordArray = wordArray.map((word) => {
        const letterArray = word.split('');
        const firstLetterUppercaseWord = letterArray.map((letter, index) => index === 0 ? letter.toUpperCase() : letter.toLowerCase());

        const finalWordString = firstLetterUppercaseWord.join``;

        return finalWordString;
    });

    return mappedWordArray.join(' ');
};